import React from "react";
import Layout from "./src/components/Layout";
import ErrorBoundary from "./src/components/ErrorBoundary"
import IdentityContextProvider from './src/contexts/IdentityContext'


export const wrapPageElement = ({ element }) => (
  <Layout>
    <ErrorBoundary>{element}</ErrorBoundary>
  </Layout>
);

export const wrapRootElement = ({ element }) => <IdentityContextProvider>{element}</IdentityContextProvider>;
